import {
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Input,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import {
  fetchViewQuotationById,
} from '../../slices/quotation';
import PrintQuotation from '../Authentication/PrintQuotation'
import html2pdf from 'html2pdf.js';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const ViewQuotationList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [quotationData, setQuotationData] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const { user: currentUser } = useSelector(state => state.auth);

  const printRef = useRef();

  const handleDownloadPDF = () => {
    const element = printRef.current;
    if (!element) return;

    setLoadingPDF(true);
    const clone = element.cloneNode(true);
    clone.querySelectorAll('.no-print').forEach(el => el.remove());
    const logo = clone.querySelector('img.company-logo');
    if (logo) {
      const logoWrapper = document.createElement('div');
      logoWrapper.style.backgroundColor = 'white';
      logoWrapper.style.display = 'inline-block';
      logoWrapper.style.padding = '6px';
      logoWrapper.style.borderRadius = '4px';
      logoWrapper.style.textAlign = 'center';

      logo.parentNode.insertBefore(logoWrapper, logo);
      logoWrapper.appendChild(logo);
    }
    const imageElements = Array.from(clone.querySelectorAll('img')).filter(img => {
      const src = img.getAttribute('src') || '';
      return !img.classList.contains('company-logo') && !src.includes('logo.png');
    });

    const style = document.createElement('style');

    style.innerHTML = `
    * {
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #000000 !important;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
      }
      @page {
        size: A4 portrait;
        margin: 10mm !important;
      }
      body {
        font-size: 9px !important;
        margin: 0 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
      }
      .print-container-quotation {
        width: 794px !important;
        min-height: 1000px !important;
        position: relative !important;
        padding-bottom: 100px !important;
        margin: 0 auto !important;
      }
      .main-heading {
        font-size: 15px !important;
        text-align: center !important;
        width: 100% !important;
      }
      .page {
        page-break-after: always !important;
        position: relative !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .header-text {
        font-size: 10px !important;
        line-height: 1.2 !important;
        text-align: left !important;
      }
      .page-content {
        width: 100% !important;
        overflow: visible !important;
        font-size: 10px !important;
      }
      .signature-section {
        position: absolute !important;
        bottom: 10px !important;
        width: 100% !important;
        text-align: center !important;
        margin-top: 0 !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
      }
      .terms-and-bank-container {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        page-break-before: always !important;
        height: 100vh !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: space-between !important;
        width: 794px !important;
        margin: 0 auto !important;
      }
      .terms-content-wrapper {
        flex: 1 !important;
        overflow: hidden !important;
      }
      .bank-details-wrapper {
        margin-top: auto !important;
        padding-top: 20px !important;
      }
      .bankDetails {
        font-size: 11px !important;
        margin-left: 5px !important;
        line-height: 1.1 !important;
      }
      .ant-row {
        display: flex !important;
        flex-wrap: wrap !important;
        margin-bottom: 5px !important;
      }
      .ant-col {
        box-sizing: border-box !important;
        padding: 1px !important;
      }
      h1, h2, h3, h4, h5 {
        color: rgb(2, 15, 28) !important;
        font-size: 12px !important;
        margin-bottom: 3px !important;
        margin-top: 0 !important;
      }
      .ant-table {
        width: 794px !important;
        font-size: 9px !important;
        table-layout: fixed !important;
        margin: 5px 0 !important;
        border-collapse: collapse !important;
      }
      .ant-table-container {
        overflow: visible !important;
        border: 1px solid #dee2e6 !important;
        padding: 0px !important;
        width: 794px !important;
      }
      .ant-table-wrapper {
        padding: 0 !important;
        overflow: visible !important;
        width: 794px !important;
      }
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        padding: 2px 2px !important;
        font-size: 8px !important;
        background-color: white !important;
        border: 1px solid #dee2e6 !important;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        word-break: break-word !important;
        line-height: 1.1 !important;
        height: auto !important;
        min-height: 18px !important;
      }
      .ant-table-thead > tr > th {
        background: #fff !important;
        padding: 2px !important;
        font-weight: bold !important;
      }
      .ant-table-wrapper .ant-table-summary > tr > td {
        border: 1px solid #dee2e6 !important;
        padding: 1px 1px !important;
        font-size: 8px !important;
      }
      .summary-cell-center {
        text-align: center !important;
      }
      .summary-cell-right {
        text-align: right !important;
        padding-right: 3px !important;
      }
      .ant-divider {
        margin: 5px 0 !important;
        border-top: 1px solid #d9d9d9 !important;
      }
      .no-print {
        display: none !important;
      }
      .terms-heading {
        font-size: 12px !important;
        margin-bottom: 4px !important;
        text-align: center !important;
      }
      .terms__content ul li {
        font-size: 8px !important;
      }
      .terms__content {
        font-size: 8px !important;
        text-align: justify !important;
        line-height: 1.1 !important;
        max-width: 100% !important;
        margin: 0 auto !important;
        padding: 0 5px !important;
      }
      .terms__content h3 {
        font-weight: 600 !important;
        margin: 3px 0 !important;
        font-size: 10px !important;
      }
      img {
        max-width: 100% !important;
      }
      .customer-details {
        margin-bottom: 5px !important;
      }
      .customer-details-header {
        background-color: #12406a !important;
        color: white !important;
        padding: 2px 5px !important;
        font-weight: bold !important;
        margin-bottom: 2px !important;
        font-size: 9px !important;
      }
      .customer-details-content {
        padding: 3px 5px !important;
      }
      .logo-section img {
        max-width: 150px !important;
        height: auto !important;
        position: absolute !important;
        top: 0 !important;
        right: 0 !important;
      }
      .kind-attention {
        text-align: right !important;
      }
      .date-quotation {
        text-align: right !important;
      }`;
    clone.appendChild(style);
    const base64ConversionPromises = imageElements.map(img => {
      const src = img.getAttribute('src');
      if (!src || src.startsWith('data:') || img.classList.contains('company-logo')) {
        return Promise.resolve();
      }

      return loadImageAsBase64(src)
        .then(base64 => {
          img.setAttribute('src', base64);
        })
        .catch(err => {
          console.warn('Failed to load base64 image:', src, err);
        });
    });
    const logoImage = clone.querySelector('img.company-logo');
    if (logoImage && !logoImage.src.startsWith('data:')) {
      base64ConversionPromises.push(
        loadImageAsBase64(logoImage.src)
          .then(base64 => {
            logoImage.setAttribute('src', base64);
          })
          .catch(err => {
            console.warn('Failed to load base64 logo:', logoImage.src, err);
          })
      );
    }
    Promise.all(base64ConversionPromises)
      .then(() => {
        setTimeout(() => {
          const opt = {
            margin: 0,
            filename: 'quotation.pdf',
            image: { type: 'png', quality: 1 },
            html2canvas: {
              scale: 2,
              useCORS: true,
              allowTaint: true,
              logging: true,
              imageTimeout: 15000,
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
          };

          html2pdf().set(opt).from(clone).save()
            .then(() => setLoadingPDF(false))
            .catch(err => {
              console.error("PDF generation error:", err);
              setLoadingPDF(false);
            });
        }, 500);
      })
      .catch(err => {
        console.error("Error converting images to base64:", err);
        setLoadingPDF(false);
      });
  };


  const fetchData = async () => {
    try {
      const response = await dispatch(
        fetchViewQuotationById({
          id: id,
        }),
      ).unwrap();
      setQuotationData(response?.data);
    } catch (error) {
      console.error('Failed to fetch quotation:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Section No.',
      dataIndex: 'die_profile',
      key: 'die_profile',
      render: die_profile => {
        return <span>{die_profile?.die_number || 'N/A'}</span>;
      },
    },
    {
      title: 'Customer Ref No.',
      dataIndex: 'customer_reference_no',
      key: 'customer_reference_no',
      render: customer_reference_no => {
        return <span>{customer_reference_no || 'N/A'}</span>;
      },
    },
    {
      title: 'Profile Image',
      dataIndex: 'die_profile',
      key: 'die_profile',
      render: die_profile => {
        return die_profile?.die_diagram ? (
          <img src={die_profile.die_diagram} alt="Die Diagram" style={{ maxWidth: '60px', maxHeight: '60px', objectFit: 'contain' }} />
        ) : (
          <span>N/A</span>
        );
      }
    },
    {
      title: 'Profile Description',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => {
        const dimensions = [
          record?.die_profile?.dimension1,
          record?.die_profile?.dimension2,
          record?.die_profile?.dimension3,
          record?.die_profile?.dimension4,
        ]
          .filter(dim => dim !== null && dim !== '' && dim !== undefined && dim !== '0.00')
          .map(dim => Number(dim).toFixed(2))
          .join(' X ');

        return <span>{dimensions || 'N/A'}</span>;
      },
    },
    {
      title: 'Weight Range/Piece(kg)',
      dataIndex: 'weight_range',
      key: 'weight_range',
      render: weight_range => {
        return <span>{weight_range || 'N/A'}</span>;
      },
    },
    {
      title: 'Length(mm)',
      dataIndex: 'length',
      key: 'length',
      render: length => {
        return <span>{length || 'N/A'}</span>;
      },
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      render: pieces => {
        return <span>{pieces || 'N/A'}</span>;
      },
    },
    {
      title: 'Net Weight(kg)',
      dataIndex: 'net_weight',
      key: 'net_weight',
      render: net_weight => {
        return <span>{!isNaN(net_weight) ? Number(net_weight).toFixed(3) : 'N/A'}</span>;
      },
    },
    {
      title: 'Alloy/Temp',
      dataIndex: 'alloy_temp',
      key: 'alloy',
      render: (_, record) => {
        const alloyName = record?.alloy?.alloy_code || 'N/A';
        const alloyCode = record?.alloy?.standard_name || 'N/A';
        const temperName = record?.temper?.name || 'N/A';
        const temperCode = record?.temper?.code || 'N/A';

        return (
          <span>
            {alloyName} ({alloyCode}) / {temperName} ({temperCode})
          </span>
        );
      },
    },
    {
      title: 'Finish',
      dataIndex: 'surface_finish',
      key: 'surface_finish',
       render: (_, record) => {
        if (record && record?.jobworks_detail?.length > 0) {
          return record?.jobworks_detail.map(item => item.name).join(', ');
        }
        return 'N/A';
      },
    },
    {
      title: 'Price/Kg(Rs.)',
      dataIndex: 'price_per_kg',
      render: price_per_kg => {
        return <span>{!isNaN(price_per_kg) ? Number(price_per_kg).toFixed(2) : 'N/A'}</span>;
      },
    },
    {
      title: 'Conversion',
      dataIndex: 'conversion',
      render: (_, record) => {
        const conversion = parseFloat(record.conversion ?? 0);
        const pricePerKg = parseFloat(record.price_per_kg ?? 0);

        const sum = (pricePerKg + conversion).toFixed(2);

        return <span>{sum}</span>;
      },
    },
    {
      title: 'Total Basic Amount',
      dataIndex: 'total_basic_amount',
      key: 'total_basic_amount',
      render: total_basic_amount => {
        return <span>{!isNaN(total_basic_amount) ? Number(total_basic_amount).toFixed(2) : 'N/A'}</span>;
      },
    },
    {
      title: 'IGST (18%)',
      key: 'igst',
      render: record => {
        const igst = record?.total_basic_amount
          ? (record.total_basic_amount * 18) / 100
          : 0;
        return <span>{igst?.toFixed(2) || 'N/A'}</span>;
      },
    },
    {
      title: 'Total Amount (Rs.)',
      key: 'total_amount',
      render: record => {
        const basicAmount = record?.total_basic_amount || 0;
        const igst = (basicAmount * 18) / 100;
        const totalAmount = basicAmount + igst;

        return <span>{totalAmount.toFixed(2) || 'N/A'}</span>;
      },
    },
  ];

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'die_profile' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__die_profile__die_number';
    }
    if (sortField === 'die_profile' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__die_profile__die_number';
    }
    if (sortField === 'description' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__description';
    }
    if (sortField === 'description' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__description';
    }
    if (sortField === 'price_per_kg' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__price_per_kg';
    }
    if (sortField === 'price_per_kg' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__price_per_kg';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__length';
    }
    if (sortField === 'pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__pieces';
    }
    if (sortField === 'pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__pieces';
    }
    if (sortField === 'net_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__net_weight';
    }
    if (sortField === 'net_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__net_weight';
    }
    if (sortField === 'alloy' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__alloy__name';
    }
    if (sortField === 'alloy' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__alloy__name';
    }
    if (sortField === 'surface_finish' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__surface_finish';
    }
    if (sortField === 'surface_finish' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__surface_finish';
    }
    if (sortField === 'price_per_kg' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__price_per_kg';
    }
    if (sortField === 'price_per_kg' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__price_per_kg';
    }
    if (sortField === 'conversion' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_quotation_detail__conversion';
    }
    if (sortField === 'conversion' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_quotation_detail__conversion';
    }
    return sortingEnumKey;
  };
 

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'die_profile',
    'description',
    'weight_range',
    'length',
    'action',
    'pieces',
    'net_weight',
    'alloy_temp',
    'surface_finish',
    'price_per_kg',
    'conversion',
    'total_basic_amount',
    'igst',
    'total_amount',
    'customer_reference_no'
  ]);
  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={checkedValues => {
            handleColumnVisibilityChange(checkedValues);
          }}
        >
          <Row gutter={16}>
            <Col xs={12} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr.No.
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="die_profile">Section No.</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="customer_reference_no">Customer Ref No.</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="description">Profile Description</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="weight_range">Weight Range/Piece(kg)</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length(mm)</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="net_weight">Net Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="surface_finish">Surface Finish</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="price_per_kg">Price/Kg(Rs.)</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="conversion">Conversion</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_basic_amount">Total Basic Amount</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="igst">IGST</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="cgst">CGST</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="total_amount">Total Amount</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const loadImageAsBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const cacheBustUrl = `${url}${url.includes('?') ? '&' : '?'}nocache=${new Date().getTime()}`;

      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = cacheBustUrl;
    });
  };
  const dynamicColumns = columns.filter(column =>
    checkedList.includes(column.dataIndex || column.key),
  );
  const [modalTitle, setModalTitle] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const handleCancel = () => {
    setIsModalVisible(false);
    setPopupData(null);
    setModalTitle('');
  };

  return (
    <>
      {loadingPDF && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 48, color: '#12406a' }} spin />}
            tip="Generating PDF..."
          />
        </div>
      )}
      <div>
        <div className="sticyaction">
          <Row className="pagenamerow mb-0" justify="space-between" align="middle">
            <Col>
              <h2 style={{ margin: 0 }}>View Quotation</h2>
              <div className="bredcrumbwrp">
                <Link to="/quotation-list" className="back">
                  <Back /> BACK
                </Link>

                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/quotation-list">Quotations</Link> },
                    { title: 'View Quotation' },
                  ]}
                />
              </div>
            </Col>

            <Col>
              {currentUser.permissions.permissions.quotation.includes(
                'change_quotation',
              ) && (
                  <Button
                    type="primary"
                    style={{
                      marginBottom: '20px',

                      marginRight: '10px',
                    }}
                    icon={<EditOutlined />}
                    onClick={() => navigate(`/edit-quotation/${quotationData?.id}`)}
                  >
                    Edit Quotation
                  </Button>
                )}
              {quotationData?.status === 'Quotation' && (
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  style={{
                    marginBottom: '20px',
                    float: 'center',
                    marginRight: '10px',
                  }}
                  onClick={() =>
                    navigate(`/create-work-order-quotation/${quotationData?.id}`)
                  }
                >
                  Convert To Work Order
                </Button>
              )}
              {currentUser.permissions.permissions.quotation.includes(
                'print_quotation_pdf_copy',
              ) && (
                  <Tooltip placement="top" title={'Download PDF'}>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      style={{ marginBottom: '20px', float: 'right' }}
                      onClick={handleDownloadPDF}
                    >
                      Download PDF
                    </Button>
                  </Tooltip>
                )}
              <div style={{ display: 'none' }}>
                <div ref={printRef} style={{ width: '700px' }}>
                  <PrintQuotation />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className='formwrapper'>
          <Row gutter={[16, 16]} className="viewform">
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Number</label>
              {quotationData?.quotation_no || 'N/A'}
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Quotation Date</label>
              <div className="customvalue">
                {quotationData
                  ? dayjs(quotationData.quotation_date).format('DD-MM-YYYY')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Customer Name</label>
              <div className="customvalue">
                {quotationData?.customer?.customer_name}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">WorkOrder No.</label>
              <div className="customvalue">
                {quotationData?.workorder_no || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Mode Of Packing</label>
              <div className="packing_type">
                {quotationData?.packing_mode_details?.length
                  ? quotationData.packing_mode_details.map(item => item.name).join(', ')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Project Name</label>
              <div className="project_name">
                {quotationData?.project_name || 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Converted Date</label>
              <div className="customvalue">
                {quotationData?.converted_date
                  ? dayjs(quotationData.converted_date).format('DD-MM-YYYY')
                  : 'N/A'}
              </div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Status</label>
              <div className="customvalue">{quotationData?.status || 'N/A'}</div>
            </Col>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label className="customlabel">Remarks</label>
              <div className="customvalue">{quotationData?.remarks || 'N/A'}</div>
            </Col>

            <Modal
              title={modalTitle}
              visible={isModalVisible}
              onCancel={handleCancel}
              footer={null}
              width={800}
            >
              {popupData ? (
                <img
                  src={popupData}
                  alt="Image"
                  style={{ width: '100%', height: 'auto' }}
                />
              ) : (
                <p>No diagram available.</p>
              )}
            </Modal>
          </Row>

          <Divider />

          <div className="flex justify-between gridtitle">
            <h3>Quotation Items List</h3>
            <Space size="small">
             
              <Tooltip placement="topLeft" title="Column Filter Options">
                <Dropdown
                  overlay={columnMenu}
                  trigger={['click']}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button
                    type="primary"
                    icon={<ColumnList />}
                    onClick={e => e.preventDefault()}
                  />
                </Dropdown>
              </Tooltip>
            </Space>
          </div>

          <Table
            className="px-0"
           rowKey={(record) => record.id}
            dataSource={quotationData?.quotation_details || []}
            columns={dynamicColumns}
            pagination={false}    
            scroll={{ x: 1500 }}
          />
        </div>
      </div>
    </>
  );
};

export default ViewQuotationList;
